
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class CardNotTicket extends Vue {
  @Prop() title!: string;
  @Prop() body!: string;
  @Prop() src!: string;
}
